import { AIAuthProvider } from './lib/AIAuthContext';
import { useChatOwner } from './hooks/useChatOwner';
import { useChatStore } from './hooks/useChatStore';
import { useChatShortcut } from './hooks/useChatShortcut';
import { ChatLauncherButton } from './components/ChatLauncherButton.tsx';
import { ChatPanel } from './components/ChatPanel';
import type { AIAuthContextValue } from './lib/AIAuthContext';

export type AIProps = AIAuthContextValue;

export function AI(props: AIProps) {
  const isOpen = useChatStore((state) => state.isOpen);
  const isOwner = useChatOwner(props.user?.id);
  useChatShortcut();

  if (!isOwner) {
    return null;
  }

  return (
    <AIAuthProvider value={props}>
      {isOpen ? <ChatPanel /> : <ChatLauncherButton />}
    </AIAuthProvider>
  );
}
